// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { deviceModelAffordanceId } from './DeviceModelAffordance';
import { z } from 'zod';
export const deviceAffordanceId = (z.number());
export const deviceAffordance = z.object({
    id: deviceAffordanceId,
    device_id: deviceId,
    affordance_id: z.string(),
    type: z.string(),
    refs: z.unknown(),
    params: z.unknown(),
    group_label: z.string().nullable(),
    sort_order: z.number().nullable(),
    is_active: z.boolean(),
    last_seen_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    size: z.string().nullable(),
    model_affordance_id: deviceModelAffordanceId.nullable(),
    visible_when: z.unknown().nullable(),
    controlled_when: z.unknown().nullable(),
});
export const deviceAffordanceInitializer = z.object({
    id: deviceAffordanceId.optional(),
    device_id: deviceId,
    affordance_id: z.string(),
    type: z.string(),
    refs: z.unknown().optional(),
    params: z.unknown().optional(),
    group_label: z.string().optional().nullable(),
    sort_order: z.number().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    size: z.string().optional().nullable(),
    model_affordance_id: deviceModelAffordanceId.optional().nullable(),
    visible_when: z.unknown().optional().nullable(),
    controlled_when: z.unknown().optional().nullable(),
});
export const deviceAffordanceMutator = z.object({
    id: deviceAffordanceId.optional(),
    device_id: deviceId.optional(),
    affordance_id: z.string().optional(),
    type: z.string().optional(),
    refs: z.unknown().optional(),
    params: z.unknown().optional(),
    group_label: z.string().optional().nullable(),
    sort_order: z.number().optional().nullable(),
    is_active: z.boolean().optional(),
    last_seen_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    size: z.string().optional().nullable(),
    model_affordance_id: deviceModelAffordanceId.optional().nullable(),
    visible_when: z.unknown().optional().nullable(),
    controlled_when: z.unknown().optional().nullable(),
});
//# sourceMappingURL=DeviceAffordance.js.map